import React from 'react'
import './ComingSoon.scss'

import Header from '../../components/Header'
import Footer from '../../components/footer'

import cominSoon from '../../assets/svg/Comingsoon.svg'

export default function index() {
  return (
    <div className='comingsoon'>
      <Header name={'رستوران کانولی'} />
      <div className='body'>
      </div>
      <div className='scroll'>
        <div className='comingsoonSection'>
          <div className='comingsoonBody'>
            <img src={cominSoon} alt='coming soon' />
            به زودی
          </div>
        </div>
      </div>
      
      <Footer page={'home'} />
    </div>
  )
}
